
import { Event } from '@process-advisor/process-miner/api/events';
import { getEventEmitter } from '@process-advisor/process-miner/processMiner/processMiner';

export type Props = {
    data: {
        type: string,
        activity: string,
    }
}

export const openActivityStepAnalysisModal = ({ data }:  Props) => {
    let eventEmitter = getEventEmitter()
    eventEmitter.emit(Event.openActivityStepAnalysisModal, { data });
};

